import React from 'react';
import cn from 'classnames';
import Icon from '../Icon/Icon';
import { motion } from 'framer-motion';

import closeIcon from 'icons/close.svg';

export default class Modal extends React.PureComponent {
  componentDidMount() {
    window.addEventListener('keydown', this.onKeyDown);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.onKeyDown);
  }

  onKeyDown = (e) => {
    if (e.keyCode === 27) {
      this.props.hideModal();
    }
  };

  render() {
    const { hideModal } = this.props;

    const { position } = this.props;

    return (
      <div className={cn('modal', position && `modal--${position}`)}>
        <div className="modal__overlay" onClick={hideModal} />
        <div className="modal__wrapper">
          <motion.div
            animate={{ opacity: 1, scale: 1 }}
            initial={{ opacity: 0, scale: 0.5 }}
            className="modal__content"
          >
            <Icon
              glyph={closeIcon}
              onClick={hideModal}
              className="modal__close"
            />
            {this.props.children}
          </motion.div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/Modal/Modal.jsx